import React from 'react';
import { Props } from './Columns.types';
import styles from './Columns.module.scss';

const Columns: React.FC<Props> = ({ children, spacing }) => {
  return (
    <div className={`${styles.columns} m-${spacing}`}>
      {React.Children.map(children, (child) => (
        <div className={`${styles.column} p-${spacing}`}>{child}</div>
      ))}
    </div>
  );
};

export default Columns;
